import { useEffect, useState } from "react";
import ShellCard from "../ShellCard.jsx";
import PackageCard from "../PackageCard";

const CountyDrivingLessonsTemplate = ({
  heroImage,
  title,
  subTitle,
  courses,
  disclaimerText,
  whyMetroTitle = "Why Metro Traffic School?",
  whyMetroContent,
}) => {
  const [hoveredCardId, setHoveredCardId] = useState(null);

  useEffect(() => {
    document.title = `${title} - Metro Traffic School`;
  }, [title]);

  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            background: `url(${heroImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">{title}</h1>
              <p className="banner-subheading">{subTitle}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="online-traffic-school-page container pt-5">
        <div className="row g-4">
          {courses.map((c) => (
            <div className="col-12 col-sm-6 col-lg-4" key={c.id}>
              <PackageCard
                pkg={{
                  ...c,
                  registerLink: c.registerUrl,
                  description: (
                    <div style={{ whiteSpace: "pre-line" }}>
                      {c.description}
                    </div>
                  ),
                }}
                hoveredCardId={hoveredCardId}
                setHoveredCardId={setHoveredCardId}
                registerText="Register"
              />
            </div>
          ))}
        </div>

        {disclaimerText && (
          <div className="container row py-5">
            <div className="col-12">
              <p className="text-white mb-0 p-3">{disclaimerText}</p>
            </div>
          </div>
        )}
      </section>

      <section className="container pb-5">
        <div className="row">
          <div className="col-12">
            <ShellCard>
              <div className="row">
                <div className="col-12">
                  <div className="mb-4">
                    <h5 className="mb-3 fw-bold" style={{ color: "var(--metro-yellow)" }}>
                      {whyMetroTitle}
                    </h5>
                    {whyMetroContent}
                  </div>
                </div>
              </div>
            </ShellCard>
          </div>
        </div>
      </section>
    </>
  );
};

export default CountyDrivingLessonsTemplate;
